module.exports = __webpack_public_path__ + "static/Q4Answer5_Funny_PriscillaDuPreez-ab8cd77662ae8976bc2dc0f24cc53b42.jpg";